/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Error_Sort2Inputs */

const vi_cmspostcategory_error_sort2 = /** @type {(inputs: Cmspostcategory_Error_Sort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ tự là số nguyên từ 0 đến 10000.`)
};

/**

* @param {Cmspostcategory_Error_Sort2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_error_sort2 = /** @type {((inputs?: Cmspostcategory_Error_Sort2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Error_Sort2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_error_sort2(inputs)
});
export { cmspostcategory_error_sort2 as "cmsPostCategory_error_sort" }